import { useTranslation } from 'react-i18next'
import { SheetModal } from '../sheet-modal'
import { useWindowActions } from '../../../../models/window'
import { formatNumbers } from '../../../../core/helpers/format-numbers'
import { useAutoTranslate } from '../../../../core/hooks/useAutoTranslate'

import c from './confirm-modal.module.scss'

const ConfirmModal = ({ 
    title, 
    subtitle,
    caseName,
    casePrice,
    caseCategory,
    onConfirm, 
    onCancel,
    confirmText,
    cancelText 
}) => {
    const { t } = useTranslation()
    const { closeWindow } = useWindowActions()
    
    // Автоперевод названия кейса
    const translatedCaseName = useAutoTranslate(caseName)
    
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm()
        }
        closeWindow()
    }

    const handleCancel = () => {
        if (onCancel) {
            onCancel()
        }
        closeWindow()
    }
    
    // Генерируем текст в зависимости от категории
    const getCategoryWarning = () => {
        if (caseCategory === 'PUBG_MOBILE') {
            return 'Учтите он будет работать только в разделе игры PUBG MOBILE'
        }
        return 'Учтите он будет работать только в разделе игры Standoff 2'
    }

    return (
        <SheetModal>
            <div className={c.component}>
                <div className={c.main}>
                    <p className={c.title}>
                        {title || 'Подтверждение покупки'}
                    </p>
                    <p className={c.subtitle}>
                        ВЫ УВЕРЕНЫ ЧТО ХОТИТЕ КУПИТЬ КЕЙС <strong>{translatedCaseName}</strong> ЗА {formatNumbers(casePrice)} МОНЕТ?
                    </p>
                    <p className={c.warning}>
                        {getCategoryWarning()}
                    </p>
                </div>
                <div className={c.bottom}>
                    <button
                        type="button"
                        className={c.btnConfirm}
                        onClick={handleConfirm}
                    >
                        <span>{confirmText || 'Да'}</span>
                    </button>
                    <button
                        type="button"
                        className={c.btnCancel}
                        onClick={handleCancel}
                    >
                        <span>{cancelText || 'Нет'}</span>
                    </button>
                </div>
            </div>
        </SheetModal>
    )
}

export default ConfirmModal

